export default __webpack_public_path__ + "static/media/swapLogo.82141c62.png";